export default {
  DELETE_FILE_SUCCESS: 'De inhoud is verwijderd.',
  ADD_CONTENT: 'Inhoud toevoegen om te delen',
  ADD_CONTENT_INFO: 'Upload hier uw documenten, links, afbeeldingen of ander materiaal om ze te delen met uw bezoekers.',
  NO_CONTENT: 'Je hebt nog geen bestanden of links toegevoegd!',
  UPLOAD_FILES: 'Bestanden uploaden',
  ADD_URL: 'URL toevoegen',
  ADDED_CONTENT: "Toegevoegde bestanden en URL's",
  URL: 'Url',
  ADD_URL_SUCCESS: 'URL succesvol gegenereerd en opgeslagen!',
  DISPLAY_NAME: 'Weergavenaam',
  BROCHURE: 'Brochure',
  CHOOSE_FILE: 'Bestand kiezen',
  DRAG_DROP: 'Slepen en neerzetten',
  TO_UPLOAD: 'uploaden',
  MAX_FILE_SIZE: 'Maximaal 3mb maat is toegestaan',
  MAX_LEN_ERR: 'Lengte van de bestandsnaam te lang',
  MAX_SIZE_ERR: 'De limiet voor bestandsgrootte overschrijdt',
  FILES_UPLOAD_SUCCESS: 'Bestanden succesvol geüpload'
}
